import _ from "underscore";
import React from "react";
import PropTypes from "prop-types";
import Api from "utils/api";
import { Modal2, ModalConfirm } from "@evertrue/et-components";
import { Formik } from "formik";
import ModalEditor from "../../../components/modal-editor";
import { launchToast } from "./account-actions";

const EmmaAddModal = ({ isOpen, onClose, refresh, onSuccess }) => {
  const [submitting, setSubmitting] = React.useState(false);

  const handleSubmit = (values) => {
    setSubmitting(true);
    Api.EMMA.ACCOUNTS.post({
      data: values,
      disableAlerts: true,
    })
      .then(refresh)
      .then(() => {
        setSubmitting(false);
        onSuccess();
        onClose();
      })
      .catch((error) => {
        setSubmitting(false);
        launchToast(error, "error");
      });
  };

  return (
    <Modal2
      contentStyle={{ width: 440 }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Formik
        validateOnMount={true}
        initialValues={{
          name: "",
          public_api_key: "",
          private_api_key: "",
          remote_id: "",
        }}
        validate={(value) => {
          let errors = {};
          if (_.contains(value, "")) errors = { errors: true };
          return errors;
        }}
      >
        {({ errors, values, dirty, touched }) => (
          <ModalConfirm
            hasMargin={true}
            header="Add Emma Account"
            onSubmit={() => handleSubmit(values)}
            closeModal={onClose}
            closeOnSubmit={false}
            saveLabel="Add Account"
            disableSave={
              Boolean(Object.keys(errors).length) || !dirty || !touched || submitting
            }
            saveButtonType="submit"
          >
            <ModalEditor.FormField
              autoComplete="off"
              label="Emma Account Name"
              placeholder="What do you want to call this account in EverTrue?"
              name="name"
            />
            <ModalEditor.FormField
              autoComplete="off"
              label="Public API Key"
              placeholder="Public API key from Emma"
              name="public_api_key"
            />
            <ModalEditor.FormField
              autoComplete="off"
              label="Private API Key"
              placeholder="Private API key from Emma"
              name="private_api_key"
            />
            <ModalEditor.FormField
              autoComplete="off"
              label="Emma Account ID"
              placeholder="123456"
              name="remote_id"
            />
          </ModalConfirm>
        )}
      </Formik>
    </Modal2>
  );
};

EmmaAddModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default EmmaAddModal;
